import {Dispatch} from "redux";
import {MixesAPI} from "../services/api/Api";
import {IBrands, IMix} from "../constants/types";

const GET_SHARE_MIX_START = 'Share/GET_SHARE_MIX_START';
const GET_SHARE_MIX_SUCCESS = 'Share/GET_SHARE_MIX_SUCCESS';
const UPDATE_SHARE_MIX = 'Share/UPDATE_SHARE_MIX';

interface IShareState {
    isLoading: boolean,
    shareMix: Array<IMix>
}

interface IShareAction {
    type: string,
    payload: any
}

const initialState: IShareState = {
    isLoading: true,
    shareMix: []
};

const setShareMix = (res: Array<IBrands>) => ({
    type: GET_SHARE_MIX_SUCCESS,
    payload: res
});

export const getShareMIx = (id: number) => (dispatch: Dispatch) => {
    dispatch({type: GET_SHARE_MIX_START});
    MixesAPI.getMixesByIds([id])
        .then(res => dispatch(setShareMix(res)))
        .catch(e => console.error(e))
};

const changeShareMix = (countLikes: number, isLiked: boolean) => ({
    type: UPDATE_SHARE_MIX,
    payload: [countLikes, isLiked]
});

export const updateShareMix = (id: number, isMixLiked: boolean) => {
    return async (dispatch: Dispatch) => {
        if (isMixLiked) {
            const res = await MixesAPI.unlikeMix(id);
            dispatch(changeShareMix(res.likeCount, false));
        } else {
            const res = await MixesAPI.likeMix(id);
            dispatch(changeShareMix(res.likeCount, true,));
        }
    }
};

const shareReducer = (state = initialState, action: IShareAction): IShareState => {

    switch (action.type) {

        case GET_SHARE_MIX_START:
            return {
                ...state,
            };

        case GET_SHARE_MIX_SUCCESS:
            return {
                ...state,
                shareMix: action.payload,
                isLoading: false
            };

        case UPDATE_SHARE_MIX: {
            const newState: any = [...state.shareMix];
            const [likeCount, isLiked] = action.payload;
            newState[0].isLiked = isLiked;
            newState[0].likeCount = likeCount;
            return {
                ...state,
                shareMix: newState
            }
        }

        default:
            return state;
    }
};

export default shareReducer;
